export default __webpack_public_path__ + "static/media/zany-face.1f27d69c.png";